<template>
  <div id="SpecialIssues">
    <div>
      <h3>Special Issue</h3>
      <hr>
      <div>
        <strong><a target="_blank" href="https://onlinelibrary.wiley.com/page/journal/14679671/homepage/featured-collections#3">Transactions in GIS | Virtual Geographic Environment </a></strong><br>
        <br>
        <p>
          The geographic environment is a huge and complex system,
          in which existing various natural processes, human activities,
          and information interactions. Researchers have made and are continually
          making efforts in understanding this complicated environment. In addition to
          in-depth exploration in a single discipline, study that integrating knowledge
          from multiple fields is getting more and more attention. Following such a trend,
          Virtual Geographic Environment (VGE) was proposed as a new generation of geographic analysis
          tool. The construction of a VGE brings Geographic Information Science (GIS) together with natural
          geography and human geography, and it mainly aims to form a digital twin of the real world.
          In a VGE, different experiments can be conducted and potential solutions for the real world
          can be explored based on geographic rules. In this context, we propose a Special Issue that
          targets on constructing VGE based on ubiquitous geographic information, which
          can support better modeling and simulation of the real world.
        </p>

        <p>Full details of the call are available <a target="_blank" href="https://onlinelibrary.wiley.com/pb-assets/14679671/TGIS%20SI%20Virt%20Geo%20Enviro%20Construction-1611337805923.pdf">here. </a></p>

      </div>
      <hr style="border-bottom:3px double grey;">
      <div class="col-xs-12 col-md-12">
        <strong style="font-size: 1.2rem"><a target="_blank" href="https://www.journals.elsevier.com/applied-energy/call-for-papers/special-issue-on-energy-digitization-with-spatial-intelligen">Applied Energy | Energy digitization with spatial intelligence</a></strong><br>
        <br>
        <p>
          The digitization of energy systems provides potential growth
          in energy efficiency by integrating and analyzing data for
          environmental management. Three emerging trends in using digital
          technology, active energy management systems (EMSs), data-driven
          consumer engagement platforms, and new performance-based revenue
          models, support the significant improvement of energy efficiency.
          Specifically, data detection technologies (e.g., sensors and smart meters)
          are used not only to collect data on the production process but also to determine energy consumption factors.
        </p>
        <p>Full details of the call are available <a target="_blank" href="https://www.journals.elsevier.com/applied-energy/call-for-papers/special-issue-on-energy-digitization-with-spatial-intelligen">here. </a></p>

      </div>
      <hr style="border-bottom:3px double grey;">
      <div class="col-xs-12 col-md-12">
        <strong style="font-size: 1.2rem;"><a target="_blank" href="https://www.frontiersin.org/research-topics/20199/smart-urban-environmental-health-from-multi-scale-multimedia-multi-exposure-multi-target-perspective">Smart Urban Environmental Health from Multi-Scale, Multimedia, Multi-Exposure, Multi-Target Perspectives</a></strong><br>
        <br>
        <p>
          Over half of the global population live in urbanized areas.
          These areas have become the geographic focus of resource consumption and
          chemical emissions. Pollutants among the urban environmental multi-media
          (including water, soil, air, etc.) are intensifying, causing chronic public
          health risk and increase in hazard via multi-exposure pathways and multi-scale
          distribution differences. One way to measure the impact is with the Environmental
          Health Risk Management (EHRM), widely used as a policy tool. This multi-disciplinary
          tool collects data for hazard identification, exposure assessment, dose-response
          assessment, risk characterization, and risk countermeasures.

        </p>
        <p>Full details of the call are available <a target="_blank" href="https://www.frontiersin.org/research-topics/20199/smart-urban-environmental-health-from-multi-scale-multimedia-multi-exposure-multi-target-perspective">here. </a></p>
      </div>
      <hr style="border-bottom:3px double grey;">
      <div class="col-xs-12 col-md-12">
        <strong style="font-size: 1.2rem;"><a target="_blank" href="https://www.mdpi.com/journal/water/special_issues/hydroinformatics_data">Water | Advances in Hydroinformatics for Water Data Management and Analysis</a></strong><br>
        <br>
        <p>
          Recent years have witnessed a massive increase in the volume and quality of
          water data available to aid water resources decision makers, managers, and
          scientists. This has been accompanied by exponential growth in both desktop
          and cloud computing data storage and computational capabilities. As a result,
          there are abundant opportunities to drastically change how water data are collected,
          managed, disseminated, and analyzed—which should ultimately have significant positive
          impacts on water science, engineering, and management. Indeed, we are at the beginning
          of a new era in water data science, which brings with it many new and interesting technological
          and scientific challenges and opportunities. This Special Issue of Water is intended to bring
          together some of the latest research on hydroinformatics for water data management and analysis.
          Toward this goal, we are seeking submissions in a wide range of topics including data collection
          and analysis tools and technologies, hydrologic information systems, distributed hydrologic modeling and simulation,
          open water data initiatives, big data in hydrology, geographic information technologies in water data, and related areas.

        </p>

        <p>Full details of the call are available <a target="_blank" href="https://www.mdpi.com/journal/water/special_issues/hydroinformatics_data">here. </a></p>

      </div>
      <i class="el-icon-paperclip"><a href="http://175.27.137.60:8083/data/901235cd-1e8d-464b-a46a-70835fd611ad" class="greenColor">&nbsp;&nbsp;Receipt Form for Participation in the Seminar on Space Intelligence and Energy Digital Development</a></i>

    </div>
  </div>
</template>

<script>
export default {
  name: 'SpecialIssues'
}
</script>

<style lang="less" scoped>
#SpecialIssues {
  font-size: 1.2rem;
  line-height: 2rem;
  text-align: justify;
  width: 65%;
  margin: 0 auto;
  position: relative;
  word-spacing: 0.3rem;
  margin-top: 2.2rem;
}

hr {
  border: 0.1px solid;
  border-color: #eeeeee;
}

h3 {
  color: #117450;
  font-size: 1.3rem;
  font-weight: 1000;
}

a {
  text-decoration: none;
  color: #117450;
}
</style>